module.exports = __webpack_public_path__ + "img/cch1.0e42dada.jpg";